module.exports = __webpack_public_path__ + "src/assets/images/full-screen-exit-50.619fee7885d30ef7ecdf503ba7fa2875.png";